import { DefaultHardStop } from "components/AppendixScreen/DefaultHardStop";
import { HOW_TO_CONTACT_US_TITLE } from "screens/Title.const";
import { COMPREHENSION_TOP_TEXT, CONTACT_US_HEADER } from "./HardStops.const";

export const ComprehensionHardstop = () => {
  document.title = HOW_TO_CONTACT_US_TITLE;
  return (
    <DefaultHardStop header={CONTACT_US_HEADER}>
      {COMPREHENSION_TOP_TEXT}
    </DefaultHardStop>
  );
};
